import classNames from 'classnames';
import { CompanyBranchDepartmentSelector } from './CalendarCompanyBranchDepartmentSelector';
import { useFilterContext } from './FilterContext';
import { FavouriteIcon } from '@tymbe/ui-icons';
import { PrimaryButton, SecondaryButton } from '@tymbe/ui-primitives/*';
import useSearchString from '../../hooks/UrlParamsHandler/useSearchParams';

type CompanyFilterModalProps = {
  className?: string;
  start: string;
  end: string;
};

export const CompanyFilterModal = ({ className, start, end }: CompanyFilterModalProps) => {
  const { isShown, setShown } = useFilterContext();

  const [searchParams, setSearchParams] = useSearchString();
  const removeFilters = () => {
    const noParams = new URLSearchParams(searchParams);

    noParams.delete('company_id');
    noParams.delete('branchoffice_id');
    noParams.delete('department_id');

    setSearchParams(noParams);
  };

  const onRemoveFiltersClickHandler = () => {
    removeFilters();
    setShown(false);
  };

  return (
    <div>
      {isShown && (
        <div
          className={classNames(
            'flex flex-col h-full w-full bg-bg rounded-3xl drop-shadow-lg',
            { hidden: !isShown },
            className
          )}
        >
          <div className="flex items-center justify-between px-4 py-6 border-b-[1px] border-secondary-100">
            <span className="text-heading-4-md">Vyberte</span>
            <FavouriteIcon
              name="close"
              className="size-5 text-secondary-500 cursor-pointer"
              onClick={() => setShown(false)}
            />
          </div>

          <div className="p-4 mb-auto">
            <CompanyBranchDepartmentSelector isFloating start={start} end={end} />
          </div>

          <div className="flex gap-2 p-4">
            <SecondaryButton
              variant="outlined-error"
              className="w-fit flex justify-center flex-0 gap-2 text-body-2-md"
              onClick={onRemoveFiltersClickHandler}
            >
              <div className="w-[20px] h-[20px]">
                <FavouriteIcon
                  name="delete"
                  className="size-5 cursor-pointer text-red-500"
                />
              </div>
              Vymazat
            </SecondaryButton>
            <PrimaryButton
              className="w-full flex gap-2 justify-center"
              onClick={() => setShown(false)}
            >
              <FavouriteIcon
                name="check"
                className="size-5 text-secondary-500 cursor-pointer"
              />
              Uložit
            </PrimaryButton>
          </div>
        </div>
      )}
    </div>
  );
};

export default CompanyFilterModal;
